import { createConsumer } from "@rails/actioncable";
import { useEffect, useRef } from "react";

interface StageMoved {
  type: "stage_moved";
  candidate_id: number;
  full_name: string;
  from_stage: string;
  to_stage: string;
}

type PipelineMessage = StageMoved;

interface Handlers {
  onStageMoved?: (data: StageMoved) => void;
}

// Subscribes to PipelineChannel and fires callbacks on incoming messages.
export function usePipelineUpdates({ onStageMoved }: Handlers = {}) {
  const subscriptionRef = useRef<ReturnType<ReturnType<typeof createConsumer>["subscriptions"]["create"]> | null>(null);

  useEffect(() => {
    const consumer = createConsumer();
    subscriptionRef.current = consumer.subscriptions.create("PipelineChannel", {
      received(data: PipelineMessage) {
        if (data.type === "stage_moved") {
          onStageMoved?.(data);
        }
      },
    });

    return () => {
      subscriptionRef.current?.unsubscribe();
      consumer.disconnect();
    };
  }, []);
}
